<div class="bg-taures-gradient-horizon-vertical w-full h-full flex items-center justify-center">
  <div class="flex flex-row gap-6">
    <div>
      <img ngSrc="assets/wartung.png" alt="Wartungsarbeiten Symbolbild" height="263" width="333" />
    </div>
    <div class="flex flex-col justify-center">
      <div class="flex flex-col gap-2">
        <span class="h1-semibold taures-neutrals-900-opacity-a75"
          >Wir machen kurz sauber, gleich geht's<br />
          weiter.</span
        >
        <span class="bodytext-regular-multiline taures-neutrals-900">Diese Seite wird gerade gewartet.</span>
        <div>
          <div class="zeitfenster">
            <span class="smalltext-regular-multiline taures-neutrals-600">Voraussichtliches Zeitfenster</span>
            <span class="bodytext-semibold-multiline taures-primary-blue-800">
              {{ wartungStart() | date: 'HH:mm' }} – {{ wartungEnde() | date: 'HH:mm' }} Uhr
            </span>
            <span class="smalltext-regular-multiline taures-neutrals-600">{{ wartungStart() | date: 'EEEE, d. MMMM y' }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
